module.exports = __webpack_public_path__ + "img/loader.b1b1361e.gif";